import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-lp-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lp-footer.component.html',
  styleUrl: './lp-footer.component.css'
})
export class LpFooterComponent {
  currentYear = new Date().getFullYear();
}
